<template>
  <div class="row max-height-vertical box-overflow">
    <div class="row scroll-outer scroll-padding-bottom" ref="scrollHookOne">
      <div class="span-14-lg offset-1-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
        <p class="large" v-html="title"></p>
        <p class="utility bump-up-24 bump-down-12-mobile"><strong>Click</strong> through each tile to flip before proceeding to <strong>'Next'</strong> button. </p>
      </div>
      <!-- content.cards -->
      <flip-card v-for="(card, index) in markedCards" v-bind:ind="index" v-bind:active="active" v-bind:key="index" v-bind:icon="card.icon" v-bind:title="card.title" v-on:flip="change_flip_count" v-bind:cardSize="card_size">
        <p v-html="card.paragraph"></p>
      </flip-card>
    </div>
  </div>
</template>

<script>
  import flip_card from '../../components/molecules/flip_card'
  import header_block from '../../components/organisms/header_block'
  import marked from 'marked'
  import {is_active} from '../../utils/is_active'

  import 'nodelist-foreach-polyfill'; // ie11

  import PerfectScrollbar from 'perfect-scrollbar';

  export default {
    props: ['title', 'content', 'active'],
    components: {
      'header-block': header_block,
      'flip-card': flip_card
    },
    data () {
      return {
        flipped: 0,
        psOne: null
      }
    },
    methods: {
      scrollBarInit () {
        if (window.innerWidth > 1200 && window.innerHeight > 600 && !this.psOne) {
          const containerOne = this.$refs.scrollHookOne
          this.psOne = new PerfectScrollbar(containerOne);
        } else if (window.innerWidth <= 1200 && this.psOne || window.innerHeight <= 600 && this.psOne) {
          this.psOne.destroy()
          this.psOne = null
        }
        window.addEventListener('resize', this.scrollBarInit)
      },
      change_flip_count (inc) {
        this.flipped += inc
        is_active(this, this.conditional())
      },
      conditional () {
        return this.active && this.flipped < this.content.cards.length
      },
      activeCallback () {
        let int = 800
        if (this.active) {
          setTimeout(() => {
            this.scrollBarInit()
          }, int)
          setTimeout(() => {
            if (this.psOne) this.psOne.update()
          }, int + 1000)
        }
      }
    },
    computed: {
      card_size () {
        return this.content.cards.length
      },
      markedCards () {
        if(this.content.cards) {
          return this.content.cards.map((card) => {
            return {
              paragraph: marked(card.paragraph),
              icon: card.icon,
              title: card.title
            }
          })
        }
      }
      
    },
    mounted () {
      this.activeCallback()
    },
    watch: {
      active () {
        is_active(this, this.conditional())
        this.activeCallback()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// flip_card_page.vue?1c55be78